import { Link } from "react-router-dom";
import DropDownMenu from "./DropDownMenu";

export default function HeaderNav() {
    return (

        <nav className="headerNav">
            <Link to="/home" className="navItem">
                <img src="/images/home.png" alt="home" className="navIcon" />
                <span className="navLabel">hjem</span>
            </Link>
            <Link to="/drills" className="navItem">
                <img src="/images/spil.png" alt="alle spil" className="navIcon" />
                <span className="navLabel">alle spil</span>
            </Link>
            <DropDownMenu />
        </nav>
    
    )

}